import { CustomMeasureProvider, defToMeasure } from 'services/model/customMeasures';
import { InterpretationValue } from 'models/measureInterpretation';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { useIntl } from 'react-intl';

// Measures backing the Article Visibility breakdown table columns. These correspond to real TB
// measures (see `TBMeasure.kt`'s `*_ART_NUM`/`*_ART_RATE` entries and their frozen `*ArtNumCD`/
// `*ArtRateCD` codes), but are kept out of the shared `services/model/model.service.ts` measure
// catalogue because they only ever exist within the Article Visibility module/pages and can't be
// combined with the rest of the TB measures there (e.g. via `getMeasuresByMetrics`).
export const useArticleVisibilityMeasures = () => {
  const intl = useIntl();
  return {
    actArtNumCD: defToMeasure(
      {
        code: 'actArtNumCD',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.actArtNumCD.name',
      },
      intl
    ),
    inaArtNumCD: defToMeasure(
      {
        code: 'inaArtNumCD',
        interpretation: InterpretationValue.Negative,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.inaArtNumCD.name',
      },
      intl
    ),
    expArtNumCD: defToMeasure(
      {
        code: 'expArtNumCD',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.expArtNumCD.name',
      },
      intl
    ),
    nexArtNumCD: defToMeasure(
      {
        code: 'nexArtNumCD',
        interpretation: InterpretationValue.Negative,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.nexArtNumCD.name',
      },
      intl
    ),
    asrOnlArtNumCD: defToMeasure(
      {
        code: 'asrOnlArtNumCD',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.asrOnlArtNumCD.name',
      },
      intl
    ),
    asrNonArtNumCD: defToMeasure(
      {
        code: 'asrNonArtNumCD',
        interpretation: InterpretationValue.Negative,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.asrNonArtNumCD.name',
      },
      intl
    ),
    slgArtNumCD: defToMeasure(
      {
        code: 'slgArtNumCD',
        interpretation: InterpretationValue.Positive,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.slgArtNumCD.name',
      },
      intl
    ),
    nslArtNumCD: defToMeasure(
      {
        code: 'nslArtNumCD',
        interpretation: InterpretationValue.Negative,
        unitCode: MeasureUnitCode.RATE,
        translationId: 'articleVisibility.measure.nslArtNumCD.name',
      },
      intl
    ),
  } as CustomMeasureProvider;
};
